export const CARTEIRA = () => `/carteira`;
